<template lang="pug">
.post-form__section.--edit
  component(
    ref="field"
    :is="sectionComponent"
    :section="section"
    :section-index="sectionIndex"
    v-on="$listeners"
  )
</template>

<script>
import PostFormSectionDefault from '@/components/post/default-editor/post-form__section--default'
import PostFormSectionHtml from '@/components/post/default-editor/post-form__section--html'
import PostFormSectionImage from '@/components/post/default-editor/post-form__section--image'
import PostFormSectionOembed from '@/components/post/default-editor/post-form__section--oembed'

export default {
  name: 'post-form__section',
  components: {
    PostFormSectionDefault,
    PostFormSectionHtml,
    PostFormSectionImage,
    PostFormSectionOembed,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      preview: true,
    }
  },
  computed: {
    sectionComponent() {
      switch (this.sectionType) {
        case 'oembd':
          return PostFormSectionOembed
        case 'img':
        case 'image':
          return PostFormSectionImage
        case 'html':
          return PostFormSectionHtml
        default:
          return PostFormSectionDefault
      }
    },
    sectionType() {
      return this.section.kind || 'default'
    },
  },
  methods: {
    resize() {
      this.$refs.field.resize()
    },
    focus() {
      this.$refs.field.focus()
    },
    error(msg) {
      this.$refs.field.error(msg)
    }
  },
}
</script>

<style lang="sass">
.post-form__section.--edit:focus
  outline: none
</style>

